/** Types of @see ExitObjectOutput. */
export enum ExitObjectOutputType {
  intent = 'INTENT',
  value = 'VALUE',
  variable = 'VARIABLE',
}
